import * as Yup from "yup";
import * as React from "react";
import { useFormik } from "formik";
import styles from "../styles.module.css";
import { Heading, Button } from "../../Shared";

const Question: React.FC<{
	onSaveAnswer: any;
	answer: string;
	answers: Array<{
		label: string;
		value: string;
	}>;
	question: string;
	progress: number;
}> = ({ onSaveAnswer, answer, answers, question, progress }) => {
	const [loading, setLoading] = React.useState<boolean>(false);

	const formik = useFormik({
		initialValues: {
			answer: answer,
		},
		validationSchema: Yup.object({
			answer: Yup.string().required("Please select an answer."),
		}),
		onSubmit: (values: any) => {
			setLoading(true);
			onSaveAnswer(values.answer);
			setLoading(false);
		},
	});

	return (
		<>
			<div className="progress mb-5" style={{ height: "5px" }}>
				<div
					className="progress-bar progress-bar-striped  bg-success"
					style={{ width: `${progress}%` }}
				></div>
			</div>
			<Heading title={question} variant={4} isBold={false} />
			<form onSubmit={formik.handleSubmit}>
				<div className="row gy-3 mb-5 mt-3">
					<div className="col-12">
						<div
							className="alert alert-primary d-flex align-items-center"
							role="alert"
						>
							<i className="bi bi-info-circle"></i>
							<div className="ms-3">Please choose an option below.</div>
						</div>
					</div>
					{formik.touched.answer && formik.errors.answer
						? formik.errors.answer &&
						  typeof formik.errors.answer === "string" && (
								<div className="col-12">
									<div
										className="alert alert-danger d-flex align-items-center"
										role="alert"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="16"
											height="16"
											fill="currentColor"
											className="bi bi-exclamation-square-fill me-3"
											viewBox="0 0 16 16"
										>
											<path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
										</svg>{" "}
										<div>{formik.errors.answer}</div>
									</div>
								</div>
						  )
						: null}
					{answers.map((obj) => {
						return (
							<div className="col-12 col-md-6" key={`energy-${obj.value}`}>
								<div
									onClick={() => formik.setFieldValue("answer", obj.value)}
									className={`card shadow-sm bg-off-white ${
										formik.values.answer == obj.value
											? styles.selected_card
											: null
									}`}
								>
									<div className="card-body text-center">
										<div className={styles.form_check}>
											<input
												onChange={formik.handleChange}
												className={styles.form_check_input}
												type="radio"
												name="answer"
												id={`energy-${obj.value}`}
												value={obj.value}
												checked={formik.values.answer == obj.value}
											/>
											<label
												className="form-check-label"
												htmlFor={`energy-${obj.value}`}
											>
												{obj.label}
											</label>
										</div>
									</div>
								</div>
							</div>
						);
					})}
				</div>
				<Button
					type="submit"
					name="answer"
					title="Continue"
					isLoading={loading}
				/>
			</form>
		</>
	);
};

export default Question;
